












import { Component } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';

import { ParamApi } from '../Bitacora/types/Bitacora.type';

import moment from 'moment';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ColDef,
} from 'ag-grid-community';

import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';

import ReportesBajasTransitoFilters from './ReportesBajasTransitoFilters.vue';
import ReportesBajasTransitoBtnActions from './ReportesBajasTransitoBtnActions.vue';
import { fetchMS } from './fetchMS';

@Component({
  components: {
    MantenedorGrid,
    ReportesBajasTransitoFilters,
    ReportesBajasTransitoBtnActions,
  },
})
export default class ReportesBajasTransitoBase extends ComponenteBase {
  funcionalidad: Funcionalidades = Funcionalidades.ReportesBajasTransito;

  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  dataList: any[] = [];

  readonly accionesTotales: PermisoAccion[] = [
    {
      accionCodigo: 1,
      visible: false,
    },
  ];

  paramApi: ParamApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
  };

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  private colsGrid(): ColDef[] {
    const cols = [
      { field: 'Serie Número', id: 'serienumero' },
      { field: 'Equipo', id: 'tipoeqname' },
      { field: 'Fecha Baja', id: 'fecha_baja' },
      { field: 'Nombre Baja', id: 'nombre_baja' },
      { field: 'Ubicación', id: 'tipoubicaname' },
      { field: 'Cliente', id: 'cliente' },
      { field: 'SIM', id: 'sim_card' },
    ];

    return cols.map(col => ({
      headerName: col.field,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      minWidth: 200,
      width: 200,
    }));
  }

  handleMainGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridEvent = event;
    this.reloadGrid(this.paramApi);
  }

  async reloadGrid(params: ParamApi) {
    this.dataList = await this.get(params);
    this.gridApi.setRowData(this.dataList);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleFilters(params: ParamApi = {}) {
    this.paramApi = { ...params };
    this.reloadGrid(params);
  }

  async get(params: ParamApi) {
    try {
      this.loadingService.showLoading(null, 'get');
      const result = await fetchMS({ body: { ...params } });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.gridApi.showNoRowsOverlay();
        throw new Error(MENSAJE_RESPUESTA);
      }
      return [...LISTA];
    } catch (error) {
      if (error instanceof Error && error.message !== 'Network Error') {
        this.$snotify.error(error.message, { timeout: 3000 });
      } else {
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
      }
      return [];
    } finally {
      this.loadingService.hideLoading('get');
    }
  }
}
